import type { DatadogConfig } from '@susu/datadog'

export const datadogConfig = {
  applicationId: 'ac9c9ac5-d0e8-41e2-876f-f831b439470f',
  clientToken: 'pubc93e9a51c2cfc132a4042d9bd443c2b9',
  service: 'preference-center',
  // Preference center is embedded in SFCC email campaigns and accessed by customers.
  platform: 'sfcc',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 5,
  defaultPrivacyLevel: 'mask-user-input',
} as const satisfies Partial<DatadogConfig>
